import { useStore } from '../store'
import { IDENTITY_ACTIONS } from '../store/identity'

const useCurrentIdentity = () => {
  const { state, dispatch } = useStore()

  const setCurrentIdentity = (identity) => {
    dispatch({ type: IDENTITY_ACTIONS.SET_IDENTITY, identity })
  }

  return { currentIdentity: state.identity, setCurrentIdentity }
}

export default useCurrentIdentity
